import { createContext, useContext } from 'react';
import type { SvgIconStyleTypes } from '../schema/FluentSvgIcon.types';

export const SvgIconStylesContext = createContext<SvgIconStyleTypes>(null);

export const useSvgIconStylesContext = (): SvgIconStyleTypes => {
    const svgIconStylesContext = useContext(SvgIconStylesContext);
    return svgIconStylesContext;
};
